export class ClippingPlane {
    /**
     * [Point] Origin of the clipping plane 
     */
    public location: number[];

    /**
     * [Direction] 	direction of the clipping plane
     */
    public direction: number[];
}